// Central API client for the BREAKPOINT web app.
// All requests go to our backend proxy (REACT_APP_BACKEND_URL + /api/...),
// which forwards them to the live production backend.

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export const TOKEN_KEY = "@breakpoint_access_token";
export const ADMIN_KEY = "@breakpoint_is_admin";

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token, isAdmin) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(ADMIN_KEY, isAdmin ? "true" : "false");
  } catch (e) {
    console.warn("localStorage unavailable:", e);
  }
}

export function clearToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ADMIN_KEY);
  } catch (e) {
    console.warn("localStorage unavailable:", e);
  }
}

// Safely parse JSON — never throws on non-JSON (e.g. 502 HTML pages).
export async function safeJson(res) {
  try {
    const text = await res.text();
    return JSON.parse(text);
  } catch {
    return null;
  }
}

// Core fetch wrapper. `path` should start with /api/...
export async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };
  if (token) headers["X-Access-Token"] = token;
  return fetch(`${API_BASE}${path}`, { ...options, headers });
}

// Convenience helpers returning parsed JSON (or null).
export async function apiGet(path) {
  const res = await apiFetch(path, { method: "GET" });
  return safeJson(res);
}

export async function apiPost(path, body) {
  const res = await apiFetch(path, {
    method: "POST",
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  return safeJson(res);
}

export { API_BASE };
